import { render, staticRenderFns } from "./TableCustomField.vue?vue&type=template&id=2d24f570&scoped=true&"
import script from "./TableCustomField.vue?vue&type=script&lang=js&"
export * from "./TableCustomField.vue?vue&type=script&lang=js&"
import style0 from "./TableCustomField.vue?vue&type=style&index=0&id=2d24f570&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d24f570",
  null
  
)

export default component.exports